import styled from 'styled-components';
import {device} from '../../../styled/device';
import Input from 'components/acommon/FieldInput';
import {Tabs} from '../../acommon/Tabs';

export const StyledModalForm = styled.form`
  a {
    margin-right: 0;
  }

  button {
    margin-top: 40px;

    @media (max-width: ${device.mobileXL}) {
      display: block;
      margin: 0 auto 0;
    }
  }
`;

export const TabsTaxes = styled(Tabs)`
  & .tabs_tabs-links {
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));

    & .tabs_tabs-button {
      font-size: 17px;
      padding: 0;
    }
  }
`;

export const TaxesModalTitle = styled.div`
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 31px;
  margin-bottom: 20px;
`;

export const TaxesModalRow = styled.div`
  display: flex;
  margin: 26px 0 45px;
`;

export const InputAge = styled(Input)`
  min-width: 88px;
`;

export const TaxesModalSelectWrapper = styled.div`
  margin-left: 20px;
  width: 200%;
`;

export const Content = styled.div`
  width: 80%;
  margin: 25px 0 40px;

  @media (max-width: ${device.mobileXL}) {
    width: 100%;
  }
`;
